<script>
  /* Executable code section of the program */
  //Tools importation
  import { isChatModalOn, temporalChatAttendee,chatId,confirmationResponse,userRealTime,userLocalData  } from "../../apis/storage";
  import { onMount } from "svelte";

  //Component importation
  import ChatComponent from "../Chat/ChatComponent.svelte";

  //Auxiliary variables
  let localUser = {}
  let id



  //Function to undisplay modal
  const undisplayModal = () => {
    localStorage.setItem(`lastMessage-${$chatId}`,Date.now())
    $isChatModalOn = false;
    
  };

  //Inicial functions
  onMount(async() => {
    localUser = $userLocalData
    
    if ($confirmationResponse !=="") {
      id = $chatId
    }
    else{
      $chatId = `${$temporalChatAttendee.id}-${localUser[0].id}`
    }
    localStorage.setItem(`lastMessage-${$chatId}`,Date.now())
  });

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="principalContainer">
  <div class="contentContainer">
    <div class="headerContent">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-x-circle icon"
        viewBox="0 0 16 16"
        on:keypress={undisplayModal}
        on:click={undisplayModal}
      >
        <path
          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
        />
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
        />
      </svg>
    </div>
    <div class="bodyContent">
        <ChatComponent/>
    </div>
  </div>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Pricipal styles */
  .principalContainer {
    position: fixed;
    top: 0;
    background-color: rgba(0, 0, 0, 0.432);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding: 10px 30px;
    z-index: 888;
  }
  .contentContainer {
    width: 30%;
    height: auto;
    min-height: 50vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* Content */
  /* Header */
  .headerContent {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
    width: 90%;
  }
  .icon:hover {
    cursor: pointer;
    color: red;
  }
  /* Body */
  .bodyContent{
    width: 90%;
    height: 100%;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    /* Principal styles */
  .principalContainer {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px;
  }
    .contentContainer {
    width: 60%;
    height: 80dvh;
    max-height: 90dvh;
    overflow: auto;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
      /* Principal styles */
  .principalContainer {
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 20px 10px;
  }
    .contentContainer {
    width: 100%;
    height: auto;
    max-height: 90dvh;
    overflow: auto;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  }

  /* End of the section */
</style>
